<form class="form-signin" [formGroup]="form" (submit)="submit()">
  <h1 class="h3 mb-3 font-weight-normal">Please sign in</h1>


  <label for="first_name" class="sr-only">Nombres</label>
  <input type="text" formControlName="first_name" id="first_name" class="form-control" placeholder="Nombres" required autofocus>

  <label for="last_name" class="sr-only">Apellidos</label>
  <input type="text" formControlName="last_name" id="last_name" class="form-control" placeholder="Apellidos" required autofocus>

  <label for="inputEmail" class="sr-only">Email address</label>
  <input type="email" formControlName="email" id="inputEmail" class="form-control" placeholder="Email" required autofocus>

  <label for="inputPassword" class="sr-only">Password</label>
  <input type="password" formControlName="password" id="inputPassword" class="form-control" placeholder="Password" required>

  <label for="inputPasswordConfirm" class="sr-only">Password Confirm</label>
  <input type="password" formControlName="password_confirm" id="inputPasswordConfirm" class="form-control" placeholder="Password Confirm" required>

  <button class="btn btn-lg btn-primary btn-block" type="submit">Sign in</button>
</form>
